function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { jsx as ___EmotionJSX } from "@emotion/core";
var buildTitle = _ref => {
  var totalAgencies = _ref.totalAgencies,
    locationSuffix = _ref.locationSuffix;
  return "".concat(totalAgencies, " Real Estate Agenc").concat(totalAgencies === 1 ? 'y' : 'ies').concat(locationSuffix, " | Allhomes");
};
var buildMetaData = _ref2 => {
  var _ref2$searchResultsUr = _ref2.searchResultsUrl,
    searchResultsUrl = _ref2$searchResultsUr === void 0 ? '' : _ref2$searchResultsUr,
    _ref2$localities = _ref2.localities,
    localities = _ref2$localities === void 0 ? [] : _ref2$localities,
    totalAgencies = _ref2.totalAgencies,
    locationSuffix = _ref2.locationSuffix;
  var isSingleDivision = localities.length === 1 && localities[0].type === 'DIVISION';
  var descPrefix = localities.length > 0 && totalAgencies > 0 ? "".concat(totalAgencies, " real estate agenc").concat(totalAgencies === 1 ? 'y' : 'ies', " can be found").concat(locationSuffix, ". ") : '';
  var description = "".concat(descPrefix, "Search and find qualified local agents to help you sell your property fast.");
  return [{
    name: 'description',
    content: description
  }, ...(isSingleDivision ? [] : [{
    name: 'robots',
    content: 'noindex, follow'
  }]), {
    name: 'og:title',
    content: buildTitle({
      totalAgencies,
      locationSuffix
    })
  }, {
    name: 'og:site_name',
    content: 'Allhomes'
  }, ...(isSingleDivision ? [{
    name: 'og:url',
    content: "".concat(searchResultsUrl.replace(/\/$/, '')).concat(localities[0].slug, "/")
  }] : []), {
    name: 'og:description',
    content: description
  }, {
    name: 'og:type',
    content: 'website'
  }, {
    name: 'og:image',
    content: 'https://s3-ap-southeast-2.amazonaws.com/s-cdn-bucket-1s948ezjearf9/allhomes-logo.png'
  }];
};
var Headers = _ref3 => {
  var searchResultsUrl = _ref3.searchResultsUrl,
    localities = _ref3.localities,
    totalAgencies = _ref3.totalAgencies,
    locationSuffix = _ref3.locationSuffix;
  return ___EmotionJSX(Helmet, null, ___EmotionJSX("title", null, buildTitle({
    totalAgencies,
    locationSuffix
  })), buildMetaData({
    searchResultsUrl,
    localities,
    totalAgencies,
    locationSuffix
  }).map(item => ___EmotionJSX("meta", _extends({
    key: item.name
  }, item))));
};
Headers.propTypes = {
  searchResultsUrl: PropTypes.string,
  localities: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string
  })),
  totalAgencies: PropTypes.number,
  locationSuffix: PropTypes.string
};
Headers.defaultProps = {
  searchResultsUrl: '',
  localities: [],
  totalAgencies: 0,
  locationSuffix: ''
};
export default Headers;